import React from 'react';
import {EAutocompleteOption} from 'webapp-lib/Components';

import {TranslatedSpecialityField} from '@lexian/api/casus-api';
import {useMasterdata} from '_/hooks/useMasterdata';
import i18n from '_/i18n';
import {EFAutocompleteProps} from '_/utilities/form';
import {getOptions} from '_/utilities/masterdata.utils';

import {filterByActiveState} from './ActiveFilter/ActiveFilter.utils';
import {
  ActiveStateFilterState,
  useActiveStateFilter,
} from './ActiveFilter/useActiveStateFilter';
import {
  AutocompleteBase,
  staticLoader,
} from './AutocompleteBase/AutocompleteBase';

const toOption = (
  specialityField: TranslatedSpecialityField
): EAutocompleteOption => getOptions([specialityField])[0];

type Props = Omit<EFAutocompleteProps, 'options'> & {
  multiple?: boolean;
  filterable?: boolean;
  persistenceKey?: string;
  onUserChange?: (
    specialityField: TranslatedSpecialityField | undefined
  ) => void;
};

export function SpecialityFieldAutocomplete({
  label = i18n.t('common:labels.specialityField'),
  onUserChange,
  filterable = false,
  persistenceKey = 'speciality-field-autocomplete',
  ...otherProps
}: Props): React.ReactElement {
  const {specialityFields} = useMasterdata();
  const activeStateFilter = useActiveStateFilter(
    `active-filter.specialityFieldAutocomplete.searchFilters.${persistenceKey}`
  );

  return (
    <AutocompleteBase
      {...otherProps}
      filter={filterable ? activeStateFilter : undefined}
      label={label}
      loadItems={staticLoader(
        (filterState: ActiveStateFilterState | undefined) =>
          filterByActiveState(
            specialityFields,
            filterState?.activeState ?? 'ACTIVE'
          )
      )}
      reloadTrigger={specialityFields}
      toOption={toOption}
      noOptionFiltering
      onItemChange={onUserChange}
    />
  );
}
